import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateAndUpdateFirestopDetailAndProductItems = async (
  projectId,
  {
    firestopDetailsToCreate,
    firestopDetailsToUpdate,
    firestopProductsToCreate,
    firestopProductsToUpdate,
    firestopDetailImagesToCreate,
    firestopDetailImagesToDelete,
  }
) => {
  const apiPath = `firestop-documentation/project/${projectId}/create-and-update-firestop-detail-and-product-items`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      firestopDetailsToCreate,
      firestopDetailsToUpdate,
      firestopProductsToCreate,
      firestopProductsToUpdate,
      firestopDetailImagesToCreate,
      firestopDetailImagesToDelete,
    },
  });

  const response = await axios(signedRequest);

  return response.data;
};
